import { render } from "./InventoryShowView.vue?vue&type=template&id=4d8edb3d&scoped=true"
import script from "./InventoryShowView.vue?vue&type=script&lang=js"
export * from "./InventoryShowView.vue?vue&type=script&lang=js"

import "./InventoryShowView.vue?vue&type=style&index=0&id=4d8edb3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8edb3d"]])

export default __exports__